// extracted by mini-css-extract-plugin
export default {"CollapsibleAlertSection":"cuPLiL87EgKCNsGU6zIN","CloseButton":"YobyEeuCs6aRpqULdAQJ","Variant--hidden":"Wbnx02CJxo88143d6jGb"};